// Libs
import React from 'react';
import { Alert } from 'react-bootstrap';

// Services
import AccountService from 'services/AccountService';

// Components
import Loader from 'components/common/Loader';

// Images
import logoImage from 'images/flip-logo.png';

//-------------------------------------------------------------------------------------------------------------------

class LoginByGUID extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    async componentDidMount() {
        if (this.props.guid) {

            try {
                // Try to log in
                await AccountService.logIn({
                    guid: this.props.guid
                });

                // Success
                this.props.onLogIn();
            } catch (error) {
                // Login failed
                this.setState({
                    isLoading: false,
                    error: error
                });
            }

        } else {
            this.setState({
                error: 'Sorry, the link you\'ve used to log in is invalid. Please contact support.'
            });
        }
    }

    //--------------------------------------------------------------------------------------------------------------------

    render() {
        const {
            isLoading,
            error
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (
            <div className="login-panel">
                <img src={logoImage} />

                {error ?
                    <Alert color="danger">{error}</Alert>
                : <>
                    <Loader />
                </>}

            </div>

        );
    }
}

export default LoginByGUID;